import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';

const ModalAsignarDTE = ({ show, onHide, onSuccess, idNIT }) => {
    const { token, setToken } = useToken();
    const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm();
    const { showErrorToast } = useToast();
    const [planesDocumentos, setPlanesDocumentos] = useState([]);
    const [cargandoPlanes, setCargandoPlanes] = useState(true);
    const [asignando, setAsignando] = useState(false);

    //Solicita los paquetes de dte
    const ObtenerPlanesDocumentos = async () => {
        setCargandoPlanes(true);
        const response = await fetch("/api/PlanesFacturacionBolivia/ObtenerPlanesDocumentos",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                const data = JSON.parse(responseType.detalles);
                setPlanesDocumentos(data);
            } else {
                showErrorToast(responseType.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargandoPlanes(false);
    };

    //Asignar Paquete de DTE's
    const AsignarPaqueteDTE = async (_idPlan, _idNIT) => {
        setAsignando(true);
        const response = await fetch("/api/PlanesFacturacionBolivia/AsignarPlanANIT/?_idPlan=" + _idPlan + "&_idNIT=" + _idNIT + "", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
            setAsignando(false);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {
                reset();
                setPlanesDocumentos([]);
                onSuccess();
            }
            else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setAsignando(false);
    };

    useEffect(() => {
        if (show && idNIT) {
            setValue("idNIT", idNIT);
            ObtenerPlanesDocumentos();
        }
    }, [show, idNIT]);

    const onSubmit = data => {
        AsignarPaqueteDTE(data.idBoliviaPlanesFacturacion, data.idNIT);
        console.log(JSON.stringify(data));
    };

    const handleClose = () => {
        reset();
        setPlanesDocumentos([]);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Modal.Header>
                    <Modal.Title>Asignar plan</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={handleClose} />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Debes elegir un paquete para asignar al NIT seleccionado.
                            <hr />
                        </Col>
                    </Row>
                    {cargandoPlanes ? (
                        <Row>
                            <Col className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Cargando planes disponibles...</p>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col md={12}>
                                <Form.Control
                                    type="hidden"
                                    isInvalid={!!errors.idNIT}
                                    {...register("idNIT")}
                                />
                                <Form.Group className="mb-3">
                                    <Form.Label>Paquete DTE's</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        defaultValue=""
                                        isInvalid={!!errors.idBoliviaPlanesFacturacion}
                                        {...register("idBoliviaPlanesFacturacion", {
                                            required: 'Debes seleccionar un paquete'
                                        })}
                                    >
                                        <option value="">Selecciona un paquete</option>
                                        {planesDocumentos.map((plan, index) => {
                                            return (
                                                <option key={index} value={plan.idBoliviaPlanesFacturacion}>
                                                    {plan.vPlanTitle} - {(plan.dCantidad == -1) ? "Ilimitados" : plan.dCantidad} DTE's - ${plan.dPlanPrice}USD
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.idBoliviaPlanesFacturacion && errors.idBoliviaPlanesFacturacion.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose} variant='primary' disabled={asignando}>Cerrar</Button>
                    <Button type="submit" variant='success' disabled={asignando || cargandoPlanes}>
                        {asignando ? 'Asignando...' : 'ASIGNAR PLAN'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

ModalAsignarDTE.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    idNIT: PropTypes.number
};

export default ModalAsignarDTE;
